export default __webpack_public_path__ + "static/media/loading.f19227c7.svg";